import React from 'react';
import {
  Box, Typography, Button, CircularProgress, TextField, InputAdornment,
} from '@mui/material';
import { Refresh, TrendingDown, Search, ShowChart } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const HeaderSection = ({
  loading,
  scanDate,
  onRefresh,
  lookupTicker,
  onLookupTickerChange,
  onLookupSubmit,
  lookupLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{
              width: 40, height: 40, borderRadius: 2,
              background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 3px 12px rgba(239,68,68,0.25)',
            }}>
              <TrendingDown sx={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '1.3rem', fontWeight: 900, color: '#1e293b', lineHeight: 1.2 }}>
                {t('distribution.pageTitle')}
              </Typography>
              <Typography sx={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 500 }}>
                {t('distribution.pageDesc')} • {scanDate || '—'}
              </Typography>
            </Box>
          </Box>
          <Button
            variant="outlined"
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <Refresh sx={{ fontSize: 16 }} />}
            onClick={onRefresh}
            disabled={loading}
            sx={{
              textTransform: 'none', fontSize: 13, fontWeight: 600, borderRadius: '6px',
              color: '#059669', borderColor: '#6ee7b7', px: 2,
              '&:hover': { bgcolor: '#ecfdf5', borderColor: '#10b981' },
              '&:disabled': { bgcolor: '#f1f5f9', color: '#94a3b8', borderColor: '#e2e8f0' },
            }}
          >
            {loading ? t('common.refreshing') : t('common.refresh')}
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          mb: 2,
          p: 1.5,
          borderRadius: 2,
          border: '1px solid #dbeafe',
          bgcolor: '#f8fbff',
          display: 'flex',
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          gap: 1.5,
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: '0.8rem', fontWeight: 800, color: '#0f172a', mb: 0.35 }}>
            {t('distribution.lookup.title')}
          </Typography>
          <Typography sx={{ fontSize: '0.72rem', color: '#64748b', lineHeight: 1.5 }}>
            {t('distribution.lookup.subtitle')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', md: 'auto' }, flexShrink: 0 }}>
          <TextField
            size="small"
            placeholder={t('distribution.lookup.placeholder')}
            value={lookupTicker}
            onChange={(event) => onLookupTickerChange(event.target.value.toUpperCase())}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onLookupSubmit();
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start"><Search sx={{ fontSize: 16, color: '#93c5fd' }} /></InputAdornment>,
              sx: { fontSize: '0.8rem', bgcolor: '#fff', borderRadius: 2 },
            }}
            sx={{ width: { xs: '100%', sm: 240 } }}
          />
          <Button
            variant="contained"
            onClick={onLookupSubmit}
            disabled={lookupLoading}
            startIcon={lookupLoading ? <CircularProgress size={16} color="inherit" /> : <ShowChart sx={{ fontSize: 16 }} />}
            sx={{
              minWidth: 148,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '0.78rem',
              fontWeight: 700,
              bgcolor: '#2563eb',
              boxShadow: 'none',
              '&:hover': { bgcolor: '#1d4ed8', boxShadow: 'none' },
            }}
          >
            {lookupLoading ? t('distribution.lookup.checking') : t('distribution.lookup.button')}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default HeaderSection;